import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-host-password-dialog',
    templateUrl: './host-password-dialog.component.html',
    styleUrls: ['./host-password-dialog.component.scss'],
    standalone: false
})
export class HostPasswordDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<HostPasswordDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  onNoClick(): void {
    this.dialogRef.close();
  }

  submit(): void {
    if (this.data.password) {
      this.dialogRef.close({ password: this.data.password, createTrust: this.data.createTrust || false });
    }
  }
}
